import Close from "@mui/icons-material/Close";
import MoreHoriz from "@mui/icons-material/MoreHoriz";
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Tooltip } from "@mui/material";

import type { DialogController } from "../../utils/hooks/use-dialog";
import type { BoxProps } from "@mui/material";
import type { FC } from "react";

export const More: FC<
  BoxProps & { dialog: DialogController<unknown>; tooltip?: string; type: "logo" | "colour" }
> = ({ dialog, title, tooltip, type, ...props }) => (
  <>
    <Tooltip title={tooltip ?? ""}>
      <Box
        {...props}
        sx={(theme) => ({
          width: "60px",
          height: "60px",
          borderRadius: `${theme.shape.borderRadius}px`,
          borderWidth: "1px",
          borderStyle: "solid",
          borderColor: "sidebar.divider",
          "&:hover": {
            borderColor: "text.secondary",
            color: "text.secondary",
            cursor: "pointer",
          },
          color: "primary.main",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          verticalAlign: "middle",
        })}
        onClick={dialog.handleOpen}
      >
        <MoreHoriz fontSize="large" sx={{ width: "auto" }} />
      </Box>
    </Tooltip>
    <Dialog open={dialog.open} onClose={dialog.handleClose}>
      <DialogTitle>
        {title ?? "More"}
        <IconButton
          data-analytics-id={`branding-bar-more-dialog-${type}-close`}
          aria-label="close"
          onClick={dialog.handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close data-testid="CloseIcon" />
        </IconButton>
      </DialogTitle>
      <DialogContent>{props.children}</DialogContent>
    </Dialog>
  </>
);
